export default __webpack_public_path__ + "static/media/map.513ad05b.svg";